import React, { useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";
import "./App.css";

function App() {
  const editorRef = useRef(null);
  const log = () => {
    if (editorRef.current) {
      console.log(editorRef.current.getContent());
    }
  };
  return (
    <div className="App">
      <h5>Medicine Card</h5>
      <>
        <Editor
          apiKey="f6jkcs9yyq4rb88cip56qmy4i7qlo7mhxgdfg0kmfjg8jjdr"
          onInit={(evt, editor) => (editorRef.current = editor)}
          initialValue="<p style='font-weight:bold' >আপনার ব্যক্তিগত মেডিসিন কার্ড <span style='color:green; background-color: yellow; font-weight:bold '>Meds.etc</span> -এর পক্ষ থেকে  </p>
          <table style='border-collapse: collapse; width: 441px;' border='1'>
    <tbody>
    <tr>
    <td style='width: 33.625px;'><span style='font-size: 12pt;'><strong>নাম:</strong></span></td>
    <td style='width: 204.547px;'>&nbsp;</td>
    <td style='width: 39.391px;'><span style='font-size: 12pt;'><strong>মোবাইল:</strong></span></td>
    <td style='width: 107.312px;'>&nbsp;</td>
    </tr>
    </tbody>
    </table>
    <table style='border-collapse: collapse; width: 441px; border-style: hidden;' border='0'>
    <tbody>
    <tr>
    <th style='width: 6.09112%; border-style: hidden;'><span style='font-size: 12pt;'><strong>নং.</strong></span></th>
    <th style='width: 18.3841%;'><span style='font-size: 12pt;'><strong>কারণ</strong></span></th>
    <th style='width: 28.5729%; border-style: hidden;'><span style='font-size: 12pt;'><strong>ওষুধের নাম</strong></span></th>
    <th style='width: 36.7682%;'><span style='font-size: 12pt;'><strong>খাওয়ার নিয়ম</strong></span></th>
    <th style='width: 10.1888%; border-style: hidden;'><span style='font-size: 12pt;'><strong>পরিমাণ</strong></span></th>
    </tr>
    </tbody>
    </table>
    <table style='border-collapse: collapse; width: 441px; height: 40.4376px;' border='1'>
    <tbody>
    <tr style='height: 20.2188px;'>
    <td style='width: 6%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 18%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 28%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 36%; height: 20.2188px;' colspan='3'>&nbsp;</td>
    <td style='width: 10%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    </tr>
    <tr style='height: 20.2188px;'>
    <td style='width: 12.0831%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 10.7405%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 13.09%; height: 20.2188px;'>&nbsp;</td>
    </tr>
    </tbody>
    </table>
    <table style='border-collapse: collapse; width: 441px; height: 40.4376px;' border='1'>
    <tbody>
    <tr style='height: 20.2188px;'>
    <td style='width: 6%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 18%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 28%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 36%; height: 20.2188px;' colspan='3'>&nbsp;</td>
    <td style='width: 10%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    </tr>
    <tr style='height: 20.2188px;'>
    <td style='width: 12.0831%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 10.7405%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 13.09%; height: 20.2188px;'>&nbsp;</td>
    </tr>
    </tbody>
    </table>
    <table style='border-collapse: collapse; width: 441px; height: 40.4376px;' border='1'>
    <tbody>
    <tr style='height: 20.2188px;'>
    <td style='width: 6%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 18%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 28%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 36%; height: 20.2188px;' colspan='3'>&nbsp;</td>
    <td style='width: 10%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    </tr>
    <tr style='height: 20.2188px;'>
    <td style='width: 12.0831%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 10.7405%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 13.09%; height: 20.2188px;'>&nbsp;</td>
    </tr>
    </tbody>
    </table>
    <table style='border-collapse: collapse; width: 441px; height: 40.4376px;' border='1'>
    <tbody>
    <tr style='height: 20.2188px;'>
    <td style='width: 6%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 18%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 28%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 36%; height: 20.2188px;' colspan='3'>&nbsp;</td>
    <td style='width: 10%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    </tr>
    <tr style='height: 20.2188px;'>
    <td style='width: 12.0831%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 10.7405%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 13.09%; height: 20.2188px;'>&nbsp;</td>
    </tr>
    </tbody>
    </table>
    <table style='border-collapse: collapse; width: 441px; height: 40.4376px;' border='1'>
    <tbody>
    <tr style='height: 20.2188px;'>
    <td style='width: 6%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 18%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 28%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 36%; height: 20.2188px;' colspan='3'>&nbsp;</td>
    <td style='width: 10%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    </tr>
    <tr style='height: 20.2188px;'>
    <td style='width: 12.0831%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 10.7405%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 13.09%; height: 20.2188px;'>&nbsp;</td>
    </tr>
    </tbody>
    </table>
    <table style='border-collapse: collapse; width: 441px; height: 40.4376px;' border='1'>
    <tbody>
    <tr style='height: 20.2188px;'>
    <td style='width: 6%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 18%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 28%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 36%; height: 20.2188px;' colspan='3'>&nbsp;</td>
    <td style='width: 10%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    </tr>
    <tr style='height: 20.2188px;'>
    <td style='width: 12.0831%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 10.7405%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 13.09%; height: 20.2188px;'>&nbsp;</td>
    </tr>
    </tbody>
    </table>
    <table style='border-collapse: collapse; width: 441px; height: 40.4376px;' border='1'>
    <tbody>
    <tr style='height: 20.2188px;'>
    <td style='width: 6%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 18%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 28%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 36%; height: 20.2188px;' colspan='3'>&nbsp;</td>
    <td style='width: 10%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    </tr>
    <tr style='height: 20.2188px;'>
    <td style='width: 12.0831%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 10.7405%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 13.09%; height: 20.2188px;'>&nbsp;</td>
    </tr>
    </tbody>
    </table>
    <table style='border-collapse: collapse; width: 441px; height: 40.4376px;' border='1'>
    <tbody>
    <tr style='height: 20.2188px;'>
    <td style='width: 6%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 18%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 28%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 36%; height: 20.2188px;' colspan='3'>&nbsp;</td>
    <td style='width: 10%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    </tr>
    <tr style='height: 20.2188px;'>
    <td style='width: 12.0831%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 10.7405%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 13.09%; height: 20.2188px;'>&nbsp;</td>
    </tr>
    </tbody>
    </table>
    <table style='border-collapse: collapse; width: 441px; height: 40.4376px;' border='1'>
    <tbody>
    <tr style='height: 20.2188px;'>
    <td style='width: 6%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 18%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 28%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    <td style='width: 36%; height: 20.2188px;' colspan='3'>&nbsp;</td>
    <td style='width: 10%; height: 40.4376px;' rowspan='2'>&nbsp;</td>
    </tr>
    <tr style='height: 20.2188px;'>
    <td style='width: 12.0831%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 10.7405%; height: 20.2188px;'>&nbsp;</td>
    <td style='width: 13.09%; height: 20.2188px;'>&nbsp;</td>
    </tr>
    </tbody>
    </table>
          "
          init={{
            height: 500,
            menubar: true,
            autosave_interval: "20s",
            mobile: {
              menubar: true,
              plugins: [
                "advlist autolink lists link image charmap print preview anchor ",
                "searchreplace visualblocks code fullscreen",
                "insertdatetime media table paste code help wordcount",
                "autosave",
                "save",
              ],
              toolbar:
                "undo redo | formatselect | " +
                "restoredraft" +
                "save" +
                "bold italic backcolor | alignleft aligncenter " +
                "alignright alignjustify | bullist numlist outdent indent | " +
                "removeformat | help",
            },
            plugins: [
              "advlist autolink lists link image charmap print preview anchor",
              "searchreplace visualblocks code fullscreen",
              "insertdatetime media table paste code help wordcount",
              "autosave",
              "save",
            ],
            toolbar:
              "undo redo | formatselect | " +
              "restoredraft" +
              "save" +
              "bold italic backcolor | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent | " +
              "removeformat | help",
            content_style:
              "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          }}
        />
        <button onClick={log}>Log editor content</button>
      </>
    </div>
  );
}

export default App;
